var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-user-header-container"},[_c('router-link',{staticClass:"item",class:_vm.pageKey == 'balance' ? 'active' : '',attrs:{"to":{ path: '/balance' }}},[_vm._v("充值")]),_c('router-link',{staticClass:"item",class:_vm.pageKey == 'rechargeRecord' ? 'active' : '',attrs:{"to":{ path: '/rechargeRecord' }}},[_vm._v("充值记录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }